import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from './services/modal.service';
import { LocationService } from '../../../utilities/services/location.service';

@Component({
  selector: 'app-shared-city-modal-floating-city-button',
  standalone: true,
  imports: [CommonModule],
  template: `
    <button
      (click)="openCityModal()"
      class="fixed bottom-4 right-4 bg-white shadow-lg rounded-full p-3 flex items-center space-x-2 hover:bg-gray-50 border border-gray-200 transition-all duration-300 z-50 group"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5 text-gray-500 group-hover:text-[#C90C0C]"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
          clip-rule="evenodd"
        />
      </svg>
      <span
        class="text-sm font-medium text-gray-500 group-hover:text-[#C90C0C] group-hover:opacity-100 transition-all duration-300 whitespace-nowrap"
      >
        {{ currentCity || 'Seleccionar ciudad' }}
      </span>
    </button>
  `,
  styles: [
    `
      button {
        transition: all 0.3s ease;
      }
      button:hover {
        transform: scale(1.05);
      }
    `,
  ],
})
export class FloatingCityButtonComponent {
  currentCity: string | null = null;

  constructor(
    private locationService: LocationService,
    private modalService: ModalService
  ) {
    this.locationService.location$.subscribe((location) => {
      this.currentCity = location?.city ?? null;
    });
  }

  openCityModal(): void {
    this.modalService.toggleModal(true);
  }
}
